import React from 'react';
import { useLocation } from 'react-router';

import { Auth } from 'aws-amplify';
import { logger } from '@shared/utils';

import SharedHeader from '@shared/organisms/Header';
import { useAppGlobals } from '../../contexts/AppContext';
import { headerOptions } from '../../../utils';

const Header = () => {
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const redirectParam = searchParams.get('redirect');

  const { domain, user } = useAppGlobals();

  const getLoginUrl = () => {
    if (redirectParam) {
      return `/login?redirect=${encodeURIComponent(redirectParam)}`;
    }
    return '/login';
  };

  const signOut = async () => {
    try {
      await Auth.signOut();
    } catch (e) {
      logger.error('There was an error when trying to sign user out: ', e);
    }
  };

  const options = headerOptions({ user });

  return (
    <SharedHeader
      adminOptions={[]}
      domain={domain}
      homepageUrl="/"
      loginUrl={getLoginUrl()}
      onSignOut={signOut}
      options={options.filter((o) => o.conditionalRender)}
      showProfile
      user={user}
    />
  );
};

export default Header;
